import React from 'react';
import { Box, Button, FlexBox, H1, Typography, tokensRaw } from '@vp/swan';
import styled from 'styled-components';
import { Maybe } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { useStepContext } from '@99designs/swan-wizard';
import { StepProductCard } from './StepProductCard';
import { BriefProductFragment } from './brief.generated';
import Intro from './intro.png';

const IntroStepContainer = styled(FlexBox)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointSmEnd}) {
        flex-direction: column;
        align-items: center;
    }
`;

const ImageContainer = styled.div`
    max-width: 100%;
    @media (min-width: ${tokensRaw.SwanBaseBreakpointMdEnd}) {
        margin-right: ${tokensRaw.SwanSemSpace10};
    }
`;

const ContentContainer = styled(FlexBox)`
    height: 100%;
`;

const IntroStepWrapper = styled(FlexBox)`
    height: 100vh;
    width: 100%;
`;

const ResponsiveImage = styled.img`
    width: 100%;
    height: auto;
    @media (max-width: ${tokensRaw.SwanBaseBreakpointSmEnd}) {
        width: 100%;
        height: 220px;
    }
`;

export const IntroStep = ({ product }: { product: Maybe<BriefProductFragment> }) => {
    const { next } = useStepContext();
    return (
        <IntroStepWrapper flexDirection="column" justifyContent="center" alignItems="center">
            <IntroStepContainer>
                <ImageContainer>
                    <ResponsiveImage
                        // temporary solution for storybook rendering issue
                        src={typeof Intro === 'string' ? Intro : (Intro as { src: string }).src}
                        alt="Intro layout"
                    />
                </ImageContainer>
                <ContentContainer
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    paddingX={6}
                    paddingY={0}
                >
                    <Box
                        mb={4}
                        px={2}
                        textAlign={{ xs: 'center', md: 'left' }}
                        style={{ maxWidth: '500px' }}
                    >
                        <H1 mb={5}>{__('Tell us about your design project')}</H1>
                        <Typography mb={6}>
                            {__(
                                'Answer a few short questions to help us design the perfect solution'
                            )}
                        </Typography>
                        <Box textAlign={'left'}>
                            {product && <StepProductCard product={product} />}
                        </Box>
                        <Button mt={6} width="full-width" skin="primary" onClick={next}>
                            {__('Get started')}
                        </Button>
                    </Box>
                </ContentContainer>
            </IntroStepContainer>
        </IntroStepWrapper>
    );
};
